import { render, staticRenderFns } from "./editProduct.vue?vue&type=template&id=61ba7ca9&scoped=true&"
import script from "./editProduct.vue?vue&type=script&lang=js&"
export * from "./editProduct.vue?vue&type=script&lang=js&"
import style0 from "./editProduct.vue?vue&type=style&index=0&id=61ba7ca9&prod&scoped=true&lang=less&"
import style1 from "./editProduct.vue?vue&type=style&index=1&id=61ba7ca9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ba7ca9",
  null
  
)

export default component.exports